import { useEffect } from "react";
import { assetBatchExportNotification } from "screens/assetExporter/feedConfigurationV2/ProcessNotification";
import { createLinkAndRoute } from "screens/assetExporter/sourceFeed/utils";
import { useAssetBatchesExportRequests } from "./useExportAssetBatches";
import { useExportExecutionArns } from "./useExportExecutionArns";
import { useAppSelector } from "../useAppSelector";
import { ExportDestination } from "screens/assetExporter/feedConfigurationV2/exportDrawer/shared/types";

export function useAssetBatchExportNotification() {
  const { exportExecutionArns, handleSetExportExecutionArns } =
    useExportExecutionArns();
  const {
    exportAssetBatchNames,
    exportFeedName,
    exportRowCount,
    exportClientSlug,
  } = useAppSelector(state => state.assetExporter.assetBatches);

  const assetBatchRequests = useAssetBatchesExportRequests(exportExecutionArns);

  useEffect(() => {
    assetBatchRequests.forEach(({ data: job }) => {
      if (!job) return;

      const outputs = job?.responseJson?.outputs || [];
      const exportDestination = outputs[0]?.type;
      const googleSpreadsheetOutput = outputs.find(
        output => output.type === ExportDestination.GoogleSpreadsheet,
      );
      const csvOutput = outputs.find(
        output => output.type === ExportDestination.CSVDownload,
      );

      const { fileUrl, portalUrl } = googleSpreadsheetOutput || {};

      assetBatchExportNotification({
        getCsvDownloadUrl: () => {
          if (csvOutput?.url) createLinkAndRoute(csvOutput.url);
        },
        notificationKey: job.executionId,
        onClose: () => {
          handleSetExportExecutionArns(
            exportExecutionArns.filter(arn => arn !== job.executionId),
          );
        },
        message: job.description,
        status: job.status,
        percentage: job.responseJson?.percentage ?? 0,
        exportDestination,
        onAdLibClick: () => {
          return;
        },
        portalLink: portalUrl,
        sheetLink: fileUrl,
        exportRowCount,
        exportAssetBatchNames,
        exportFeedName,
        exportClientSlug,
      });
    });
  }, [
    assetBatchRequests,
    handleSetExportExecutionArns,
    exportExecutionArns,
    exportRowCount,
    exportAssetBatchNames,
    exportFeedName,
    exportClientSlug,
  ]);
}
